// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1253) return "static/chunks/2a06def0-8dbe445af0f39e44.js";
	if (chunkId === 1327) return "static/chunks/1327-9a3a3e5229822ccd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1260":"285968eff8ae771b","4439":"6e2ef98c8eb0ed8f","4828":"8b477e08bde219a9","5894":"53d46915819aaa93","6745":"4d084b91fef51eca","7384":"12ac2b8ff62ff976"}[chunkId] + ".js";
};